// extracted by mini-css-extract-plugin
module.exports = {"button":"BigRock_button__1O7Mo","full-width-avatar":"BigRock_full-width-avatar__10MF6","moon":"BigRock_moon__16GKt"};